import {
  BarChart3,
  UserCircle,
  Package,
  WalletCards,
  UserRoundCog,
  ListTodo,
  Router,
  Settings,
  Building2,
  ClipboardList,
  CreditCard,
  Wallet,
  Shuffle,
  UserCheck,
  Users,
  Wifi,
  // Ticket,
} from 'lucide-vue-next';

const roleBasedSidebarLinks = [
  // ==================== DASHBOARD ====================
  {
    label: "sidebar.dashboard",
    href: "/",
    icon: BarChart3,
    access: ["admin", "noc", "installer", "sales", "financeAdmin", "creditChecker", "cashier"],
    show: true,
    permission: "page.dashboard"
  },
  {
    label: "sidebar.customers",
    href: "/customers-link",
    icon: UserCircle,
    access: ["admin", "cashier", "financeAdmin", "sales"],
    show: true,
    permission: "page.customersLink"
  },

  // ==================== SALES MODULE ====================
  {
    type: "header",
    label: "sidebar.modules.sales",
    access: ["admin", "sales", "financeAdmin", "creditChecker", "cashier", "cashir"],
    show: true,
  },
  {
    label: "sidebar.sales.main",
    href: "/customer",
    icon: WalletCards,
    access: ["admin", "sales", "financeAdmin", "creditChecker", "cashier", "cashir"],
    show: true,
    children: [
      // {
      //   label: "sidebar.sales.findCustomer",
      //   href: "/installations-list/search",
      //   icon: Search,
      //   access: ["admin", "sales", "financeAdmin", "creditChecker", "cashier", "cashir"],
      //   show: true,
      //   permission: "page.customerSearch"
      // },
      {
        label: "sidebar.sales.installationsList",
        href: "/installations-list",
        icon: UserCircle,
        access: ["admin", "cashier", "cashir", "sales", "creditChecker", "financeAdmin"],
        show: true,
        permission: "page.installationsList"
      },
      {
        label: "sidebar.sales.addCustomer",
        href: "/installations-list/customerForm",
        icon: UserRoundCog,
        access: ["admin", "cashier", "cashir", "sales", "creditChecker", "financeAdmin"],
        show: true,
        permission: "page.customerForm"
      },
      {
        label: "sidebar.sales.offlineCustomers",
        href: "/offline-customers",
        icon: UserCheck,
        access: ["admin", "cashier", "cashir", "sales", "financeAdmin"],
        show: true,
        permission: "page.offlineCustomers"
      },

    ],
  },
  {
    label: "sidebar.sales.resellers",
    href: "/resellers",
    icon: Users,
    access: ["admin", "cashier", "cashir", "sales", "creditChecker", "financeAdmin"],
    show: true,
    permission: "page.resellers"
  },
  {
    label: "sidebar.equipment",
    href: "/equipment/list",
    icon: Package,
    access: ["admin", "sales"],
    show: true,
    permission: "page.equipment"
  },

  // ==================== HOTSPOT MODULE ====================
  {
    type: "header",
    label: "sidebar.modules.hotspot",
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
    show: true,
  },
  {
    label: "sidebar.hotspotCustomers",
    href: "/hotspot-customers",
    icon: Wifi,
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
    show: true,
    permission: "page.hotspotParents"
  },
  // {
  //   label: "sidebar.hotspotAllowances",
  //   href: "/hotspot-allowances",
  //   icon: Ticket,
  //   access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
  //   show: true,
  //   permission: "page.hotspotAllowances"
  // },

  // ==================== NOC MODULE ====================
  {
    type: "header",
    label: "sidebar.modules.noc",
    access: ["admin", "noc", "financeAdmin", "installer"],
    show: true,
  },
  // {
  //   label: "sidebar.taskAssignment",
  //   href: "/tasks/assign",
  //   icon: ClipboardList,
  //   access: ["admin", "noc"],
  //   show: true,
  //   permission: "page.taskAssignment"
  // },
  {
    label: "sidebar.installations",
    href: "/installations",
    icon: Router,
    access: ["admin", "noc", "financeAdmin"],
    show: true,
    permission: "page.installations"
  },
  {
    label: "sidebar.tasks",
    href: "/tasks",
    icon: ClipboardList,
    access: ["admin", "financeAdmin", "installer"],
    show: true,
    permission: "page.tasks"
  },

  // ==================== FINANCE MODULE ====================
  {
    type: "header",
    label: "sidebar.modules.finance",
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
    show: true,
  },
  {
    label: "sidebar.cashSettings",
    href: "/cash-settings",
    icon: WalletCards,
    access: ["admin", "financeAdmin"],
    show: true,
    permission: "page.cashSettings"
  },
  {
    label: "sidebar.billing",
    href: "/billing",
    icon: ListTodo,
    access: ["admin", "financeAdmin", "creditChecker"],
    show: true,
    permission: "page.billing"
  },
  {
    label: "sidebar.serviceDiscounts",
    href: "/service-discounts",
    icon: ClipboardList,
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker", "sales", "noc"],
    show: true,
    permission: "page.serviceDiscounts"
  },

  {
    label: "sidebar.payments.main",
    href: "/payments",
    icon: CreditCard,
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
    show: true,
    children: [
      {
        label: "sidebar.payments.payment",
        href: "/payments/payment",
        icon: CreditCard,
        access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
        show: true,
        permission: "page.receivePayment"
      },
      {
        label: "sidebar.payments.cashLedger",
        href: "/payments/cash-ledger",
        icon: Wallet,
        access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
        show: true,
        permission: "page.cashLedger"
      },
      {
        label: "sidebar.payments.queue",
        href: "/payments/queue",
        icon: CreditCard,
        access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
        show: true,
        permission: "page.paymentQueue"
      },
      {
        label: "sidebar.payments.list",
        href: "/payments",
        icon: CreditCard,
        access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
        show: true,
        permission: "page.paymentsList"
      },
      {
        label: "sidebar.payments.hotspot",
        href: "/payments/hotspot",
        icon: CreditCard,
        access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
        show: true,
        permission: "page.hotspotPayments"
      },
    ]
  },
  {
    label: "sidebar.qboSyncReviewV2",
    href: "/quickbooks-sync-review-v2",
    icon: Shuffle,
    access: ["admin", "cashier", "cashir", "financeAdmin", "creditChecker"],
    show: true,
    permission: "page.qboSyncReview"
  },


  // ==================== ADMIN MODULE ====================
  {
    type: "header",
    label: "sidebar.modules.admin",
    access: ["admin", "noc", "financeAdmin"],
    show: true,
  },
  {
    label: "sidebar.branches",
    href: "/branches",
    icon: Building2,
    access: ["admin", "financeAdmin"],
    show: true,
    permission: "page.branches"
  },
  {
    label: "sidebar.users",
    href: "/users",
    icon: UserCircle,
    access: ["admin", "noc"],
    show: true,
    permission: "page.users"
  },
  {
    label: "sidebar.settings",
    href: "/settings",
    icon: Settings,
    access: ["admin", "financeAdmin"],
    show: true,
    permission: "page.settings"
  },

  // ==================== HIDDEN ====================
  {
    label: "sidebar.tasks",
    href: "/reset-password",
    icon: ClipboardList,
    access: ["admin", "cashier", "cashir", "noc", "financeAdmin", "sales", "installer", "creditChecker"],
    show: false,
  },
  {
    path: "servary-tickets",
    name: "ServaryTickets",
    meta: {
      requiresAuth: true,
      permission: "action.installations.tabFeedback"
    }
  }
];

export default roleBasedSidebarLinks;